//App
import { StateApiType } from "./types/apiTypes";
import apiClient from "../../apiClient/apiClient";
import endPoints from "./endPoints";

const stateApi: StateApiType = {
  get: (value) => apiClient.get(endPoints.state.get(value)),
  getAll: (payload) => apiClient.get(endPoints.state.getAll(), payload),
  save: (payload) => apiClient.post(endPoints.state.save(), payload),
  delete: (value) => apiClient.delete(endPoints.state.delete(value)),
  activate: (value) => apiClient.post(endPoints.state.activate(value)),
  searchStates: (payload) =>
    apiClient.post(endPoints.state.searchStates(), payload),
  getStatesView: (payload) =>
    apiClient.get(endPoints.state.getStatesView(), payload),

};

export default stateApi;
